<ng-content select="[payee-label]"></ng-content>
<div class="payee-input-wrapper" [class.error]="error">
  <ng-content></ng-content>
  <!-- <ng-content select="[error-icon]"></ng-content> -->
  <ng-content select="[payee-suffix]"></ng-content>
</div>
<div class="payee-errors-box" [class.error]="error" #errorsBox>
  <ng-content select="[payee-error]"></ng-content>
</div>